import { render, staticRenderFns } from "./my-form.vue?vue&type=template&id=c1cdd394&scoped=true&"
import script from "./my-form.vue?vue&type=script&lang=js&"
export * from "./my-form.vue?vue&type=script&lang=js&"
import style0 from "./my-form.vue?vue&type=style&index=0&id=c1cdd394&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cdd394",
  null
  
)

export default component.exports